import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaStar,
  FaFacebookF,
  FaTwitter,
  FaPinterestP,
  FaShareAlt,
  FaLinkedinIn,
} from "react-icons/fa";
import { products } from "../data/products";
import ProductCard from "../components/ProductCard";
import { useStore } from "../context/Storecontext";

const colors = ["#1a1a1a", "#7a7a7a", "#d32f2f", "#fdd835"];
const sizes = ["S", "M", "L", "XL", "XXL"];
const tags = ["Best", "Mother", "Vegetables", "Fruits", "Salads", "Organic"];

export default function ProductSidebarPage() {
  const product = products[0];
  const [qty, setQty] = useState(1);
  const [activeColor, setActiveColor] = useState(0);
  const navigate = useNavigate();
  const { addToCart, addToWishlist } = useStore();
  const related = products.slice(1, 5);
  const upsell = products.slice(5, 9);

  const handleAddToCart = () => {
    addToCart({ ...product, qty });
    navigate("/cart");
  };

  return (
    <div>
      <div
        className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
        style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
      >
        <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
          <h2 className="text-2xl text-black font-semibold mb-2">Blog</h2>
          <Link to="/" className="hover:text-[#43a047] transition-colors">
            Home
          </Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-600">Product Sidebar</span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <aside className="lg:w-64 flex-shrink-0">
            <div className="mb-8">
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Women
              </h3>
              <ul className="space-y-2 text-sm text-gray-500">
                <li className="flex justify-between hover:text-primary cursor-pointer">
                  <span>Dress</span>
                  <span className="text-gray-400">(5)</span>
                </li>
                <li className="flex justify-between hover:text-primary cursor-pointer">
                  <span>Bags</span>
                  <span className="text-gray-400">(8)</span>
                </li>
                <li className="flex justify-between hover:text-primary cursor-pointer">
                  <span>Clothing</span>
                  <span className="text-gray-400">(3)</span>
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Filter By Price
              </h3>
              <input
                type="range"
                min="0"
                max="100"
                className="w-full accent-primary"
              />
              <div className="flex justify-between items-center mt-2">
                <span className="text-xs text-gray-400">$0 - $100</span>
                <button className="bg-dark text-white text-xs px-3 py-1 hover:bg-primary transition-colors">
                  Filter
                </button>
              </div>
            </div>

            <div className="mb-8">
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Select By Color
              </h3>
              <ul className="space-y-2 text-sm text-gray-500">
                {["Black", "Blue", "Brown", "Green", "Pink"].map((c, i) => (
                  <li
                    key={c}
                    className="flex justify-between hover:text-primary cursor-pointer"
                  >
                    <span>{c}</span>
                    <span className="text-gray-400">({i + 4})</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Select By Size
              </h3>
              <ul className="space-y-2 text-sm text-gray-500">
                {sizes.map((s, i) => (
                  <li
                    key={s}
                    className="flex justify-between hover:text-primary cursor-pointer"
                  >
                    <span>{s}</span>
                    <span className="text-gray-400">({i + 2})</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Manufacturer
              </h3>
              <ul className="space-y-2 text-sm text-gray-500">
                {[
                  "Brand Parva",
                  "Astronomic",
                  "Frigima Brand",
                  "Renterex",
                  "Soda Splanve",
                ].map((b, i) => (
                  <li
                    key={b}
                    className="flex justify-between hover:text-primary cursor-pointer"
                  >
                    <span>{b}</span>
                    <span className="text-gray-400">({i + 3})</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Product Tags
              </h3>
              <div className="flex flex-wrap gap-2">
                {tags.map((t) => (
                  <span
                    key={t}
                    className="text-xs border border-border-color px-3 py-1.5 text-gray-500 hover:bg-primary hover:text-white hover:border-primary cursor-pointer transition-colors"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <img
                src="/img/bg/banner17.jpg"
                alt="Natural Food"
                className="w-full object-cover"
              />
            </div>
          </aside>

          {/* Main product */}
          <div className="flex-1">
            <div className="flex flex-col lg:flex-row gap-10 mb-12">
              <div className="lg:w-1/2">
                <div className="border border-border-color bg-gray-50">
                  <img
                    src={product.img1}
                    alt={product.name}
                    className="w-full h-80 object-contain"
                  />
                </div>
              </div>

              <div className="lg:w-1/2">
                <h1 className="text-2xl font-bold text-dark mb-2">
                  {product.name}
                </h1>
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <FaStar key={s} className="text-yellow-400" size={13} />
                    ))}
                  </div>
                  <span className="text-xs text-gray-400">
                    (1 customer review)
                  </span>
                </div>
                <div className="flex gap-3 items-center mb-4">
                  <span className="text-2xl font-bold text-primary">
                    ${product.price}.00
                  </span>
                </div>
                <p className="text-sm text-gray-500 leading-relaxed mb-5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                  fringilla augue nec dolor auctor. Donec non est ac libero
                  vulputate rutrum. Morbi ornare lectus mollis, ipsum gravida
                  semper.
                </p>

                <div className="mb-4">
                  <p className="text-sm font-semibold text-dark mb-2">
                    Available Options
                  </p>
                  <div className="flex items-center gap-3">
                    <span className="text-xs text-gray-500">Color</span>
                    <div className="flex gap-2">
                      {colors.map((c, i) => (
                        <button
                          key={c}
                          onClick={() => setActiveColor(i)}
                          style={{ backgroundColor: c }}
                          className={`w-6 h-6 border-2 ${activeColor === i ? "border-primary" : "border-transparent"}`}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-3 mb-5">
                  <div className="flex border border-border-color">
                    <button
                      onClick={() => setQty((q) => Math.max(1, q - 1))}
                      className="w-8 h-9 text-gray-500 hover:text-primary"
                    >
                      -
                    </button>
                    <input
                      type="text"
                      readOnly
                      value={qty}
                      className="w-10 text-center outline-none"
                    />
                    <button
                      onClick={() => setQty((q) => q + 1)}
                      className="w-8 h-9 text-gray-500 hover:text-primary"
                    >
                      +
                    </button>
                  </div>
                  <button
                    onClick={handleAddToCart}
                    className="bg-primary text-white text-sm font-semibold px-6 py-2.5 hover:bg-primary-dark transition-colors"
                  >
                    Add To Cart
                  </button>
                </div>

                <div className="flex flex-col gap-2 text-sm mb-4">
                  <button
                    onClick={() => addToWishlist(product)}
                    className="text-left text-gray-500 hover:text-primary"
                  >
                    + Add to Wishlist
                  </button>
                  <a href="#" className="text-gray-500 hover:text-primary">
                    + Compare
                  </a>
                </div>

                <p className="text-sm text-gray-500 mb-3">
                  Category:{" "}
                  <span className="text-dark">{product.category}</span>
                </p>

                <div className="flex gap-2">
                  {[
                    FaFacebookF,
                    FaTwitter,
                    FaPinterestP,
                    FaShareAlt,
                    FaLinkedinIn,
                  ].map((Icon, i) => (
                    <a
                      key={i}
                      href="#"
                      className="w-8 h-8 border border-border-color flex items-center justify-center text-gray-400 hover:text-white hover:bg-primary hover:border-primary transition-colors"
                    >
                      <Icon size={12} />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="mb-12">
              <div className="flex gap-6 border-b border-border-color mb-6">
                <button className="text-sm font-semibold text-primary border-b-2 border-primary pb-3">
                  Description
                </button>
                <button className="text-sm font-semibold text-gray-500 pb-3">
                  Specification
                </button>
                <button className="text-sm font-semibold text-gray-500 pb-3">
                  Reviews (1)
                </button>
              </div>
              <p className="text-sm text-gray-500 leading-relaxed">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                fringilla augue nec dolor auctor. Donec non est ac libero
                vulputate rutrum. Morbi ornare lectus mollis, ipsum gravida
                semper, nec commodo augue nisi non neque.
              </p>
            </div>

            {/* Related */}
            <div className="mb-12">
              <h3 className="text-xl font-bold text-dark mb-6">
                Related Products
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {related.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            </div>

            {/* Upsell */}
            <div>
              <h3 className="text-xl font-bold text-dark mb-6">
                Upsell Products
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {upsell.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
